document.addEventListener("DOMContentLoaded", function () {
  const productCards = document.querySelectorAll(".featured-product-card");

  productCards.forEach((card) => {
    let tooltip = null;

    card.addEventListener("mouseenter", function (e) {
      if (window.innerWidth < 1025) return;
      tooltip = document.createElement("div");
      tooltip.className = "featured-product-tooltip";
      tooltip.textContent = this.getAttribute("data-product-title");

      tooltip.style.cssText = `
         position: fixed;
         background: rgba(0, 0, 0, 0.2);
         color: var(--inuikii-com-white, var(--color-white-solid, #fff));
         padding: 8px 16px;
         border-radius: 4px;
         font-family: "ABC Diatype";
         font-size: 12px;
         font-style: normal;
         font-weight: 700;
         line-height: 14px;
         letter-spacing: 0.6px;
         text-transform: uppercase;
         pointer-events: none;
         z-index: 9999;
         white-space: nowrap;
         opacity: 0;
         transition: opacity 0.3s ease;
       `;

      if (document.body) {
        document.body.appendChild(tooltip);
      }

      setTimeout(() => {
        tooltip.style.opacity = "1";
      }, 10);
    });

    card.addEventListener("mousemove", function (e) {
      if (tooltip) {
        tooltip.style.left = e.clientX + 15 + "px";
        tooltip.style.top = e.clientY + -30 + "px";
      }
    });

    card.addEventListener("mouseleave", function () {
      if (tooltip) {
        tooltip.style.opacity = "0";
        setTimeout(() => {
          if (tooltip && tooltip.parentNode) {
            tooltip.parentNode.removeChild(tooltip);
          }
          tooltip = null;
        }, 300);
      }
    });
  });
});
